import {ActionHandler} from "../../infrastructure/handlers/action-handler";
import {ACTION_TYPES} from "../consts";
import {ComponentController} from "../../infrastructure/controllers/component-controller";
import {UserSelectionsManager} from "../managers/user-selections.manager";

export class EditButtonClickHandler extends ActionHandler {
  type = ACTION_TYPES.editButtonClick;
  controller: ComponentController;
  userSelectionsManager: UserSelectionsManager;

  static injectables = [...ActionHandler.injectables, UserSelectionsManager];

  constructor(userSelectionsManager: UserSelectionsManager) {
    super();

    this.userSelectionsManager = userSelectionsManager;
  }

  async action(params) {
    this.appStore.state.followingDisplayModel.onEditMode = params?.onEditMode;

    this.controller.action(ACTION_TYPES.editButtonClickAnalytics, {
      source: params.source,
      viewType: this.appStore.state.followingDisplayModel.viewType,
      numTeams: this.userSelectionsManager.competitorsIds?.length,
      numLeagues: this.userSelectionsManager.competitionsIds?.length
    });

    return params;
  }
}
